export type LanguageCode = 'nl' | 'fr' | 'de' | 'en';

type Language = {
	code: LanguageCode;
	file: `${LanguageCode}.ts`;
};

const languages: Language[] = [
	{
		code: 'nl',
		file: 'nl.ts',
	},
	{
		code: 'fr',
		file: 'fr.ts',
	},
	{
		code: 'de',
		file: 'de.ts',
	},
	{
		code: 'en',
		file: 'en.ts',
	},
];

export default languages;
